import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { BackArrowIcon } from '@karma/components/icons';
import Button from '@karma/components/Button';
import Alooma from 'services/alooma';
import * as ALOOMA from 'consts/alooma';

const BackButton = props => {
  const { t } = useTranslation();
  const { label, to, forceTo, ...other } = props;

  const contextDataAttrs = Alooma.useContextDataAttrs();

  const activePath = useSelector(state => state.activePath);

  const history = useHistory();

  const goBack = useCallback(() => {
    const { state } = history.location;

    if (forceTo) {
      /**
       * Ignores the rules below and redirects to the forceTo path; Used on coupons and items
       * see all pages;
       * Example: Home -> see all (tags) -> back
       */
      history.push(forceTo);
    } else if (state?.from) {
      /**
       * Redirects to the path defined in state.from property; The property state.from defines only
       * on clicking on see all button;
       * Example: Home -> see all (retailers) -> back
       */
      history.push(state.from);
    } else if (history.action === 'PUSH') {
      /**
       * The main rule; Redirects to the previous path in the history; It's works for the internal
       * transitions and doesn't work for the first transition;
       */
      history.goBack();
    } else if (activePath) {
      /**
       * Redirects to the activePath. Helps to return back to active path throw different difficult
       * transitions;
       * Example: Home -> retailer -> retailer -> retailer -> back -> back -> back
       */
      history.push(activePath);
    } else {
      /**
       * Redirects to the to path; It's outdated condition supported specifically for retailer page
       * with website layouts;
       */
      history.push(to);
    }
  }, [activePath, history, to, forceTo]);

  return (
    <Button
      {...contextDataAttrs}
      data-alooma-element={ALOOMA.ELEMENTS.LINK_GO_BACK}
      {...other}
      onClick={goBack}
      Icon={BackArrowIcon}
      iconPosition="left"
      type="text"
    >
      {typeof label === 'string' && label.startsWith('app:') ? t(label) : label}
    </Button>
  );
};

BackButton.propTypes = {
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  forceTo: PropTypes.string,
};

export default BackButton;
